import type { SelectOption } from '@civilgrid/ui/components';
import { type NewTransactionData, TransactionCategory } from '~/common/types';

export type TransactionFields = NewTransactionData;

export const transactionTypes: SelectOption[] = [
  {
    label: 'Debit',
    value: 'debit',
  },
  {
    label: 'Credit',
    value: 'credit',
  },
  {
    label: 'Discount',
    value: 'discount',
  },
];

export const transactionCategories: SelectOption[] = [
  {
    label: 'New Project',
    value: TransactionCategory.NewProject,
  },
  {
    label: 'Digitization',
    value: TransactionCategory.Digitization,
  },
  {
    label: 'Chain of Title',
    value: TransactionCategory.ChainOfTitle,
  },
  {
    label: 'Open Lien Report',
    value: TransactionCategory.OpenLienReport,
  },
  {
    label: 'Transaction History Report',
    value: TransactionCategory.TransactionHistoryReport,
  },
  {
    label: 'Assessor Map',
    value: TransactionCategory.AssessorMap,
  },
  {
    label: 'Utility Map Request',
    value: TransactionCategory.UtilityMapRequest,
  },
  {
    label: 'Other',
    value: TransactionCategory.Other,
  },
];
